// extracted by mini-css-extract-plugin
export default {"aggregatedData":"PlayerBattedBallAVGTable_aggregatedData__ouh2M"};